import React from 'react'
import PropTypes from 'prop-types'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import InputLabel from '@material-ui/core/InputLabel'

// @material-ui/icons
import PermIdentity from '@material-ui/icons/PermIdentity'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'

// core components
import GridContainer from '../../componentsMaterial/Grid/GridContainer.jsx'
import GridItem from '../../componentsMaterial/Grid/GridItem.jsx'
import Button from '../../componentsMaterial/CustomButtons/Button.jsx'
import CustomInput from '../../componentsMaterial/CustomInput/CustomInput.jsx'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Card from '../../componentsMaterial/Card/Card.jsx'
import CardBody from '../../componentsMaterial/Card/CardBody.jsx'
import CardHeader from '../../componentsMaterial/Card/CardHeader.jsx'
import CardIcon from '../../componentsMaterial/Card/CardIcon.jsx'
import MailOutline from '@material-ui/icons/MailOutline'
import Lock from '@material-ui/icons/Lock'

import Checkbox from '@material-ui/core/Checkbox'
import Check from '@material-ui/icons/Check'

import organizationActions from '../../redux/organization/actions'

import validationFormsStyle from './validationFormsStyle'
// redux
import { connect } from 'react-redux'
import authActions from '../../redux/auth/actions'

class ChangePass extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            OldPassword: '',
            Password: '',
            ComfirmPassword: '',
            ConfirmPasswordState: '',
            PasswordState: '',
            OldPasswordState: '',
            isEqualPass: true,
            rangpass: true,
        }
    }
    componentDidMount() {}

    submitForm = () => {
        const { ChangePass, userInfo } = this.props
        const {
            OldPassword,
            Password,
            ComfirmPassword,
            ConfirmPasswordState,
            PasswordState,
            OldPasswordState,
        } = this.state
        if (OldPassword === '') {
            this.setState({ OldPasswordState: 'error' })
        } else if (Password === '') {
            this.setState({ PasswordState: 'error' })
        } else if (ComfirmPassword === '') {
            this.setState({ ConfirmPasswordState: 'error' })
            this.setState({ isEqualPass: false })
            this.setState({ rangpass: false })
        } else if (Password.length < 6) {
            this.setState({ rangpass: false })
        } else if (Password !== ComfirmPassword) {
            this.setState({ isEqualPass: false })
            this.setState({ ConfirmPasswordState: 'error' })
        } else {
            console.log('dochange pass')
            const body = {
                password_new: Password,
                password_old: OldPassword,
                uname: userInfo.user_name,
            }
            ChangePass(body)
            // doChangePass();
        }
    }

    render() {
        const { classes } = this.props

        return (
            <div>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                        <Card>
                            <CardHeader color="rose" icon>
                                <CardIcon color="rose">
                                    <Lock />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    Đổi mật khẩu
                                </h4>
                            </CardHeader>
                            <CardBody>
                                <form>
                                    <CustomInput
                                        success={
                                            this.state.OldPasswordState ===
                                            'success'
                                        }
                                        error={
                                            this.state.OldPasswordState ===
                                            'error'
                                        }
                                        labelText="Mật khẩu cũ *"
                                        formControlProps={{
                                            fullWidth: true,
                                        }}
                                        inputProps={{
                                            onChange: event =>
                                                this.setState({
                                                    OldPassword:
                                                        event.target.value,
                                                    OldPasswordState: 'success',
                                                }),
                                            type: 'password',
                                        }}
                                    />
                                    <CustomInput
                                        success={
                                            this.state.PasswordState ===
                                                'success' && this.state.rangpass
                                        }
                                        error={
                                            this.state.PasswordState ===
                                                'error' || !this.state.rangpass
                                        }
                                        labelText="Mật khẩu mới *"
                                        formControlProps={{
                                            fullWidth: true,
                                        }}
                                        helperText={
                                            this.state.rangpass
                                                ? ''
                                                : 'Mật khẩu phải chứa ít nhất 6 kí tự'
                                        }
                                        inputProps={{
                                            onChange: event =>
                                                this.setState({
                                                    Password:
                                                        event.target.value,
                                                    PasswordState: 'success',
                                                    rangpass: true,
                                                }),
                                            type: 'password',
                                        }}
                                    />
                                    <CustomInput
                                        success={
                                            this.state.ConfirmPasswordState ===
                                                'success' &&
                                            this.state.isEqualPass
                                        }
                                        error={
                                            this.state.ConfirmPasswordState ===
                                                'error' &&
                                            !this.state.isEqualPass
                                        }
                                        labelText="Nhập lại mật khẩu mới *"
                                        helperText={
                                            this.state.isEqualPass
                                                ? ''
                                                : 'Mật khẩu cũ và mới không khớp. Vui lòng nhập lại'
                                        }
                                        formControlProps={{
                                            fullWidth: true,
                                        }}
                                        inputProps={{
                                            onChange: event =>
                                                this.setState({
                                                    ComfirmPassword:
                                                        event.target.value,
                                                    ConfirmPasswordState:
                                                        'success',
                                                    isEqualPass: true,
                                                }),
                                            type: 'password',
                                        }}
                                    />

                                    <Button
                                        color="info"
                                        onClick={this.submitForm}
                                        className={classes.registerButton}
                                    >
                                        Đổi mật khẩu
                                    </Button>
                                </form>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        )
    }
}

ChangePass.propTypes = {
    classes: PropTypes.object,
}
const mapStateToProps = state => {
    return {
        userInfo: state.auth.userInfo,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        ChangePass: body => {
            dispatch(authActions.action.changePassword(body))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(validationFormsStyle)(ChangePass))
